import React, { useEffect, useState } from "react";
import { DashboardLayout } from "../../../Layouts/Dashboard/Index";
import CustomBreadcrumb from "../../../Components/custom-breadcrumb/CustmBreadcrumb";
import AttendanceDataTable from "../../../Components/Table/attendance/AttendanceDataTable";
import { getParticipantsAttendance } from "../../../hooks/useAddParticipants";
import { ParticipantsList } from "../../../types/common";
import LoadingState from "../../../Components/Loading";

const AttendancePage = () => {
  const [loading, setLoading] = useState(false);
  const [participants, setParticipants] = useState<
    ParticipantsList[] | undefined
  >([]);
  useEffect(() => {
    setLoading(true);
    getParticipantsAttendance().then((res: any) => {
      const validParticipants = res.data.filter(
        (p: any) => p.clockedIn && p.clockedIn.seconds
      );

      const invalidParticipants = res.data.filter(
        (p: any) => !p.clockedIn || p.clockedIn === ""
      );

      // Sort valid participants by clockedIn timestamp
      validParticipants.sort(
        (a: any, b: any) => a.clockedIn.seconds - b.clockedIn.seconds
      );

      // Merge sorted valid participants first, followed by invalid ones
      const sortedParticipants = [...validParticipants, ...invalidParticipants];

      setParticipants(sortedParticipants as ParticipantsList[]);
      setLoading(false);
    });
  }, []);

  // Old export functionality removed

  return (
    <DashboardLayout>
      <div className="pt-10">
        {loading && <LoadingState />}
        <CustomBreadcrumb
          heading="Attendance"
          links={[
            { name: "Dashboard", path: "/dashboard" },
            { name: "Attendance", path: "/dashboard/attendance" },
          ]}
        />

        <div className="pt-2">
          {/* Old export button hidden */}
          <div className="pt-10">
            <AttendanceDataTable data={participants} />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AttendancePage;
